import { useIntl } from '@/intl'
import { tk, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  flex-wrap: wrap;
  padding: ${tk('spacing_xs')} ${tk('spacing_md')};

  ${Typography} {
    ${Typography.modVariant('body-md-bold')}
    text-align: left;
  }
`

const SearchValue = styled.span`
  color: ${tk('color_semantic_text_primary')};
`

export function DestinationNoResult({ inputValue }: { inputValue: string }) {
  const intl = useIntl()
  return (
    <Wrapper>
      <Typography>
        {intl.formatMessage({ id: 'quicksearch_search_no_results_text' })}
        {' '}
        <SearchValue>{inputValue}</SearchValue>
      </Typography>
    </Wrapper>
  )
}
